module.exports = __webpack_public_path__ + "img/chevron-left-solid.b8acb18c.svg";